export const PRODUCTSTATUS_CREATE_RESET = 'PRODUCTSTATUS_CREATE_RESET'
export const PRODUCTSTATUS_CREATE_SET_CREATED = 'PRODUCTSTATUS_CREATE_SET_CREATED'
export const PRODUCTSTATUS_CREATE_SET_ERROR = 'PRODUCTSTATUS_CREATE_SET_ERROR'
export const PRODUCTSTATUS_CREATE_SET_VIOLATIONS = 'PRODUCTSTATUS_CREATE_SET_VIOLATIONS'
export const PRODUCTSTATUS_CREATE_TOGGLE_LOADING = 'PRODUCTSTATUS_CREATE_TOGGLE_LOADING'
